var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fire icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.64 18.1761C7.42573 18.1761 7.32287 11.8504 7.32287 11.7475C7.32274 11.4833 7.24117 11.2254 7.08943 11.0093C6.93756 10.793 6.72275 10.6288 6.47431 10.5389C6.22989 10.4485 5.96376 10.4345 5.71118 10.4989C5.45859 10.5632 5.23145 10.7026 5.06003 10.8989C3.438 12.8566 2.28957 15.162 1.70431 17.6361C-0.159974 26.9961 4.68717 31.3675 6.84717 32.8205C8.7539 34.0799 10.9909 34.7464 13.2757 34.7363C16.6289 34.7354 19.8528 33.4413 22.2757 31.1232C24.0555 29.3993 25.3159 27.2105 25.9138 24.8057C26.5115 22.401 26.4226 19.8768 25.6572 17.5204C24.78 15.0325 23.2688 12.8167 21.2727 11.0918C18.6601 8.87179 16.9647 5.76071 16.5156 2.36196C16.4774 2.1233 16.3728 1.90017 16.2136 1.71818C16.0543 1.5363 15.8471 1.40291 15.6156 1.33339C15.3889 1.26991 15.1491 1.26991 14.9224 1.33339C14.6956 1.39687 14.4907 1.52143 14.3299 1.69339C14.1885 1.84768 10.8458 5.55053 12.4913 12.095C13.1213 14.6021 13.057 16.5048 12.3242 17.4566C11.9064 17.9471 11.2832 18.2136 10.6399 18.1766L10.64 18.1761Z",
    fill: "#827677"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fire-icon.bef19e7fd72d087a61ea78780c358384.svg";
export { ForwardRef as ReactComponent };